import React, { FC } from "react";
import { Typography } from "@mui/material";

interface Props {
  text: string;
  size?: number;
  style?: object;
}
const ErrorText: FC<Props> = ({ text, style, size = 12 }) => {
  if (!text) return null;
  return (
    <Typography
      variant="body1"
      fontSize={size}
      sx={{ color: "#f00" }}
      style={ style }
    >
      {text}
    </Typography>
  );
};

export default ErrorText;
